import React from 'react';
import Type from 'prop-types';

const TaskSection = (props) => {
  const { children } = props;

  return <>{children}</>;
};

TaskSection.propTypes = {
  children: Type.node.isRequired,
};

export default TaskSection;
